"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = exports.ChevronRightIcon = exports.ChevronLeftIcon = exports.Image = exports.VideoContainer = exports.NavigationWrapper = exports.Wrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

var _Close = _interopRequireDefault(require("../../theme/icons/Close"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    font-size: 44px;\n    color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    font-size: 44px;\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    font-size: 44px;\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 100%;\n  max-height: 80vh;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 80vh;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    flex: 1;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents["default"].div(_templateObject());

exports.Wrapper = Wrapper;
var NavigationWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject2());
exports.NavigationWrapper = NavigationWrapper;

var VideoContainer = _styledComponents["default"].div(_templateObject3());

exports.VideoContainer = VideoContainer;

var Image = _styledComponents["default"].img(_templateObject4());

exports.Image = Image;
var ChevronLeftIcon = (0, _styledComponents["default"])(_ChevronLeft["default"])(_templateObject5(), _colors["default"].lychee[100]);
exports.ChevronLeftIcon = ChevronLeftIcon;
var ChevronRightIcon = (0, _styledComponents["default"])(_ChevronRight["default"])(_templateObject6(), _colors["default"].lychee[100]);
exports.ChevronRightIcon = ChevronRightIcon;
var CloseIcon = (0, _styledComponents["default"])(_Close["default"])(_templateObject7(), _colors["default"].lychee[100]);
exports.CloseIcon = CloseIcon;